// Oylan stand: the topic of the last club lesson.
//
// oylan/build_content.py puts that topic first in the lesson list and marks it with
// oylanWeekTopic {date, title} from oylan/week_topic.json. The mark shows as a label on the
// home page until the next lesson replaces it; a lesson older than two weeks is no longer
// "this week", so the label disappears even if no new lesson was imported.

import { todayKey } from "./session";

export const WEEK_TOPIC_DAYS = 14;

function dayNumber(key) {
    const [y, m, d] = key.split("-").map(Number);
    return Date.UTC(y, m - 1, d) / 86400000;
}

export function weekTopicLabel(lesson, today = todayKey()) {
    const week = lesson?.oylanWeekTopic;
    if (!week || !/^\d{4}-\d{2}-\d{2}$/.test(week.date || "")) return null;
    const age = dayNumber(today) - dayNumber(week.date);
    if (age < 0 || age > WEEK_TOPIC_DAYS) return null;
    const [, m, d] = week.date.split("-");
    return `Тема кружка от ${d}.${m}`;
}
